import { AppEvent } from "./app-event.enum";
import { EventInterface } from "./event.interface";

export class EventData implements EventInterface {
  constructor(
    public name: AppEvent,
    public value?: any,
    ) { }
}
